import "core-js/modules/es.array.map.js";
function getGlobalThemeValue(field, propValue) {
  return function (theme) {
    var getFieldValue = function getFieldValue(value) {
      var _theme$globals$field;
      return value ? ((_theme$globals$field = theme.globals[field]) === null || _theme$globals$field === void 0 ? void 0 : _theme$globals$field[value]) || value : value;
    };
    if (Array.isArray(propValue)) {
      return propValue.map(getFieldValue);
    } else {
      return getFieldValue(propValue);
    }
  };
}
export default getGlobalThemeValue;